import { createActionGroup, props } from '@ngrx/store';
import { ConfigurationProfile } from './configuration-profile.state';
import { ErrorModel } from '@era/app';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ConfigurationProfileResolverActions = createActionGroup({
  source: 'ConfigurationProfile Resolver',
  events: {
    'Configuration Profiles Requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ConfigurationProfileApiActions = createActionGroup({
  source: 'ConfigurationProfile API',
  events: {
    'Configuration Profiles Loaded': props<{ configurationProfiles: ConfigurationProfile[] }>(),
    'Configuration Profiles Loaded Error': props<{ error: ErrorModel }>(),
  },
});
